import { createSelector } from '@reduxjs/toolkit';

const getFormTitles = (state) => state.form.formTitles;

// eslint-disable-next-line import/prefer-default-export
export const getKeyedFormTitles = createSelector(
  [getFormTitles],
  (formTitles) => formTitles?.reduce((accumulator, value) => ({ ...accumulator, [value]: { title: value } }), {}) || {},
);
